import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import SourceDestinationCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/SourceDestinationCard";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import { resetViewAllAcc } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { beneInternalTxnSuccessDetail } from "../../../redux/features/internalTransaction/internalTransactionCreate";
import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TEXT from "../../../utils/globalText";

const InternalTxnSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { beneInternalTxnSuccessData, beneInternalTxnSuccessDataError } =
    useSelector((state) => state?.internalTransactionCreate);

  const viewDetailsHandler = () => {
    navigate(
      `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${id}`,
    );
  };

  const createTxnHandler = () => {
    navigate("/internal_transaction_dashboard/create_internal_transaction");
    dispatch(resetViewAllAcc());
  };

  const dashboardHandler = () => {
    navigate("/internal_transaction_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        handleFunction: createTxnHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, []);

  useEffect(() => {
    if (
      beneInternalTxnSuccessDataError == "Request failed with status code 404"
    ) {
      navigate("*");
    }
  }, [beneInternalTxnSuccessDataError]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(beneInternalTxnSuccessDetail(id));
    }
  }, [id, dispatch]);

  return (
    <>
      <StatusContainer
        isLoading={false}
        status="success"
        hoverOption="white"
        title={
          beneInternalTxnSuccessData?.transaction[0]?.lifecycle_status ===
          "approved"
            ? "Internal transaction has been created and approved."
            : "Internal transaction created successfully."
        }
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Transaction details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: (
                    <>
                      INR
                      <span className="pl-padding-xs">
                        <FormatAmount
                          label={TEXT?.PENDING}
                          price={
                            beneInternalTxnSuccessData?.transaction[0]
                              ?.amount === undefined
                              ? 0
                              : beneInternalTxnSuccessData?.transaction[0]
                                  ?.amount
                          }
                        />
                      </span>
                    </>
                  ),
                  leftSubTitle: "Amount",
                },
              ]}
            />

            <SourceDestinationCard
              sourceData={{
                label: formatAccountNumber(
                  beneInternalTxnSuccessData?.transaction[0]
                    ?.owner_account_bank_acc_no,
                ),
                subtitle: "Source account number",
                bottomTitle:
                  beneInternalTxnSuccessData?.transaction[0]
                    ?.owner_account_ifsc_code,
                bottomSubtitle: TEXT?.IFSC_CODE,
                ifsc: beneInternalTxnSuccessData?.transaction[0]
                  ?.owner_account_ifsc_code,
                dividerColor: "var(--positive-bg)",
              }}
              destinationData={{
                label: formatAccountNumber(
                  beneInternalTxnSuccessData?.transaction[0]
                    ?.internal_account_bank_acc_no,
                ),
                subtitle: "Destination account number",
                bottomTitle:
                  beneInternalTxnSuccessData?.transaction[0]
                    ?.internal_account_ifsc_code,
                bottomSubtitle: TEXT?.IFSC_CODE,
                ifsc: beneInternalTxnSuccessData?.transaction[0]
                  ?.internal_account_ifsc_code,
                dividerColor: "var(--positive-bg)",
              }}
              lineColor="var(--text-secondary)"
              bgColor="var(--positive-card)"
            />

            {beneInternalTxnSuccessData?.transaction[0]
              ?.confidential_transaction === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: TEXT?.YES,
                    leftSubTitle: TEXT?.CONFIDENTIAL_TRANSACTION,

                    icon: ICONS?.CONFIDENTIAL_TRANSACTION_BLUE_BG,
                  },
                ]}
              />
            )}

            {beneInternalTxnSuccessData?.transaction[0].lifecycle_status ===
              "pending" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: TEXT?.PENDING,
                    leftSubTitle: TEXT?.TRANSACTION_STATUS,
                    icon: ICONS?.PENDING_BLUE,
                  },
                ]}
              />
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    !Array.isArray(
                      beneInternalTxnSuccessData?.transaction[0]?.labels,
                    ) ||
                    !beneInternalTxnSuccessData?.transaction[0]?.labels
                      ?.length ? (
                      <span>{TEXT?.NO_LABELS_ASSIGNED}</span>
                    ) : (
                      beneInternalTxnSuccessData?.transaction[0]?.labels?.map(
                        (item, index) => (
                          <span key={index}>
                            {item}
                            {index <
                              beneInternalTxnSuccessData?.transaction[0]?.labels
                                ?.length -
                                1 && ", "}
                          </span>
                        ),
                      )
                    ),
                  leftSubTitle: "Assigned labels",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default InternalTxnSuccess;
